export default __webpack_public_path__ + "static/mapa-ecdc32d33a67c0a1c13dfbd19447b584.webp";